interface AdpTracker {
	track(event: string, payload?: object): void;
}

export interface RehabLengthCostActionTrackingData {
	treeId: string;
	systemType: string;
	inspectionStandard: string;
	assetType: string;
	costSource: 'custom' | 'costTable';
}

export const trackRehabLengthCostActionAdded = (
	adp: AdpTracker | null | undefined,
	data: RehabLengthCostActionTrackingData,
): void => {
	adp?.track('CLICK_COMPONENT', {
		id: 'rehab-action-add-rehab-length-cost',
		type: 'command',
		name: 'User added a rehab-length cost action',
		attributes: {
			treeId: data.treeId,
			systemtype: data.systemType,
			inspectionstandard: data.inspectionStandard,
			assettype: data.assetType,
			costsource: data.costSource,
		},
	});
};
